import React from 'react';

import { I18n } from 'react-redux-i18n';
import { StatusBadge } from '../../../../components/common/StatusBadge';

export const DonationStatusBadgeSectionRow = (props) => {
  const {
    title,
    primaryValue,
    secondaryValue,
    primaryBackgroundColor,
    secondaryBackgroundColor
  } = props;

  return (
    <div className="view-details-content-row">
      <h4>{I18n.t(title)}</h4>
      <StatusBadge
        label={primaryValue}
        colorVariant="custom"
        backgroundColor={primaryBackgroundColor}
        className="status-bedge primary"
        testId="donation-payment-primary-status"
      />
      {secondaryValue && (
        <StatusBadge
          label={secondaryValue}
          colorVariant="custom"
          backgroundColor={secondaryBackgroundColor}
          className="status-bedge secondary"
          testId="donation-payment-secondary-status"
        />
      )}
    </div>
  );
};
